module.exports = __webpack_public_path__ + "img/tablet-VTA-VALORACION-MODIFICAR02.ba8daae5.png";